import { render, staticRenderFns } from "./productItemApiFetched.vue?vue&type=template&id=058bf21e&"
import script from "./productItemApiFetched.vue?vue&type=script&lang=js&"
export * from "./productItemApiFetched.vue?vue&type=script&lang=js&"
import style0 from "./productItemApiFetched.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports